<div class="caption-bar">
  <div class="caption">Bautagesberichte</div>
  <ion-button (click)="openConstructionDayReportFormModal(null)">
    <ion-icon size="large" name="add"></ion-icon>
  </ion-button>
</div>

<lib-construction-day-report-overview></lib-construction-day-report-overview>
